import { gql } from "@apollo/client";

const CREATE_USER = gql`mutation CreateUser($firstName: String!, $lastName: String!, $classroomUid: UUID!) {
  createUser(input: { user: { firstName: $firstName, lastName: $lastName, classroomUid: $classroomUid, userRole: HORAROJ_USER } }) {
    user {
      uid
      firstName
      lastName
    }
  }
} `;

const UPDATE_USER = gql`mutation UpdateUser($userUid: UUID!, $firstName: String!, $lastName: String!, $classroomUid: UUID)  {
  updateUserByUid(input: { userPatch: { classroomUid: $classroomUid, lastName: $lastName, firstName: $firstName }, uid: $userUid }) {
    user {
      lastName
      firstName
      uid
      classroomUid
    }
  }
} `;

const CREATE_ADMIN = gql`mutation CreateUser($firstName: String!, $lastName: String!) {
  createUser(input: { user: { firstName: $firstName, lastName: $lastName, userRole: HORAROJ_ADMIN } }) {
    user {
      uid
      firstName
      lastName
    }
  }
} `;

const LIST_USERS = gql`query ListUsers($first: Int = 100, $offset: Int = 0, $filter: UserFilter, $classroomUid: UUID){
  allUsers(
    first: $first,
    offset: $offset,
    filter: $filter,
    condition: { userRole: HORAROJ_USER, classroomUid: $classroomUid },
    orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC]){
    nodes {
      uid
      firstName
      lastName
      organizationUid
      createdAt
      classroomUid
      classroomByClassroomUid {
        uid
        name
      }
      userGroupsByUserUid{
        nodes{
          groupByGroupUid{
            uid
            name
          }
        }
      }
    }
    totalCount
  }
} `;

const LIST_ADMINS = gql`query ListAdmins($first: Int, $offset: Int = 0, , $filter: UserFilter){
  allUsers(
    first: $first,
    offset: $offset,
    filter: $filter,
    condition: { userRole: HORAROJ_ADMIN },
    orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC]){
    nodes {
      uid
      firstName
      lastName
      organizationUid
      createdAt
      adminClassroomsByUserUid{
        nodes{
          classroomByClassroomUid{
            uid
            name
          }
        }
      }
      userGroupsByUserUid{
        nodes{
          groupByGroupUid{
            uid
            name
          }
        }
      }
    }
    totalCount
  }
} `;

const LIST_SUPER_ADMINS = gql`query ListSuperAdmins($first: Int, $offset: Int = 0, , $filter: UserFilter){
  allUsers(
    first: $first,
    offset: $offset,
    filter: $filter,
    condition: { userRole: HORAROJ_SUPER_ADMIN },
    orderBy: [LAST_NAME_ASC, FIRST_NAME_ASC]){
    nodes {
      uid
      firstName
      lastName
      organizationUid
      createdAt
      lastLogin
      lastPasswordUpdate
      adminClassroomsByUserUid{
        nodes{
          classroomByClassroomUid{
            uid
            name
          }
        }
      }
      userGroupsByUserUid{
        nodes{
          groupByGroupUid{
            uid
            name
          }
        }
      }
    }
    totalCount
  }
} `;

const DELETE_USER = gql`mutation DeleteUser($userUid: UUID!) {
  deleteUserByUid(input: { uid: $userUid }){
    user{
      uid
      firstName,
        lastName
    }
  }
}
`;

const GET_USER = gql`query GetUser($userUid: UUID!){
  userByUid(uid: $userUid){
    firstName
    lastName
    uid
    classroomByClassroomUid {
      name
    }
  }
} `;

const GET_CALENDAR = gql`
mutation GetAllAppointmentForUser($userUid: UUID!, $puid: UUID!) {
  getAllAppointmentForUser(input: { uUid: $userUid, pUid: $puid }) {
    appointments {
      day
      endTime
      startTime
      endDate
      startDate
      itemUid
      title
      type
      uidType
      appointmentUid
      place
      organizer
    }
  }
} `;

const GET_ALL_APPOINTMENT_FOR_USER = gql`
mutation GetAllAppointmentForUser($userUid: UUID!, $periodUid: UUID!) {
  getAllAppointmentForUser(input: {uUid: $userUid, pUid: $periodUid}) {
    appointments {
      appointmentUid
      day
      endDate
      endTime
      itemUid
      startDate
      startTime
      type
      title
      uidType
      place
      organizer
    }
  }
}
`;

const REGISTER_USER = gql`mutation RegisterUser ($firstName: String!, $lastName: String!, $email: String!, $password: String!, $classroomUid: UUID!) {
  registerUser(
    input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      password: $password,
      classroomUid: $classroomUid}
  ) {
    user {
      firstName
      lastName
      uid
      userRole
      organizationUid
    }
  }
}
`;

const REGISTER_ADMIN = gql`mutation RegisterAdmin ($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
  registerAdmin(
    input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      password: $password}
  ) {
    user {
      firstName
      lastName
      uid
      userRole
      organizationUid
    }
  }
}
`;

const REGISTER_SUPER_ADMIN = gql`mutation RegisterSuperAdmin ($firstName: String!, $lastName: String!, $email: String!, $password: String!) {
  registerSuperAdmin(
    input: {
      firstName: $firstName,
      lastName: $lastName,
      email: $email,
      password: $password}
  ) {
    user {
      firstName
      lastName
      uid
      userRole
      organizationUid
    }
  }
}
`;

const UPDATE_PASSWORD_FOR_USER = gql`mutation UpdatePasswordForUser($userUid: UUID!, $password: String!) {
  updatePasswordForUser(input: {uUid: $userUid, password: $password}) {
    clientMutationId
  }
}`;

const UPDATE_PASSWORD = gql`mutation UpdatePassword($password: String!) {
  updatePassword(input: {password: $password}) {
    clientMutationId
  }
}`;

const GET_USER_LOGIN = gql`mutation GetLogin($userUid: UUID!) {
  getLogin(input: {uUid: $userUid}) {
    string
  }
}`;

export {
  CREATE_USER,
  UPDATE_USER,
  CREATE_ADMIN,
  LIST_USERS,
  LIST_ADMINS,
  LIST_SUPER_ADMINS,
  DELETE_USER,
  GET_USER,
  GET_CALENDAR,
  GET_ALL_APPOINTMENT_FOR_USER,
  REGISTER_USER,
  REGISTER_ADMIN,
  REGISTER_SUPER_ADMIN,
  UPDATE_PASSWORD_FOR_USER,
  UPDATE_PASSWORD,
  GET_USER_LOGIN,
};
